/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CancelCircle from './cancel-circle-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CancelCircle {...validProps} />;
}
SvgComponent.iconName = 'cancel-circle-icon';

export const CancelCircleIcon = svgIconWrapper(SvgComponent);
